import none from '../../img/leoLogo.png'

export const  hotDrinkOnCoffee=[
    {
      "id": "91",
      "title": "لاته",
      "desciption": "",
      "price": "147",
      "image": none
    },
    {
      "id": "92",
      "title": "کاپوچینو",
      "desciption": "",
      "price": "130",
      "image": none
    },
    {
      "id": "93",
      "title": "کارامل ماکیاتو",
      "desciption": "",
      "price": "147",
      "image": none
    },
    {
      "id": "94",
      "title": "موکا",
      "desciption": "",
      "price": "147",
      "image": none
    },
    {
      "id": "95",
      "title": "آیریش کافه",
      "desciption": "",
      "price": "140",
      "image": none
    },
    // {
    //   "id": "96",
    //   "title": "لاته + کروسان",
    //   "desciption": "",
    //   "price": "150",
    //   "image": none
    // },
    {
      "id": "97",
      "title": "bitter almond latte",
      "desciption": "لاته با سیروپ بادام تلخ",
      "price": "135",
      "image": none
    },
    {
      "id": "98",
      "title": "فلت وایت",
      "desciption": "",
      "price": "130",
      "image": none
    },
  ]